export default function isChrome(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }

  const userAgent = navigator.userAgent;
  const isChromium = (window as any).chrome !== undefined;
  const isOpera = userAgent.includes('OPR');
  const isEdge = userAgent.includes('Edg');

  return isChromium && !isOpera && !isEdge;
}
